<sb-card [loading]="loading">
  <div card-header>
    <b>{{'lang.deviceDetails.attributesHeadline' | translate}}</b>
  </div>
  <div card-header-more>
  </div>
  <div card-fit>
    <sb-comp-settings *ngIf="device && permissionService.hasPermission(permissionService.Permission.device_attributes_show)"
                      [device]="device"
                      [heightPx]="340"></sb-comp-settings>
  </div>
</sb-card>
